import { useState } from "react";
import { VGTIcon, type ProjektOption } from "../lib/vgt";

/** Projektauswahl per Tippen statt Dropdown. Ein Helfer hat schnell zwei
 *  Dutzend Projekte in der Liste — ein natives <select> wird dort zur
 *  Rollrutsche. Zeigt beim Fokus alle, filtert ab dem ersten Zeichen und
 *  gibt erst frei, wenn ein Eintrag der Liste getroffen ist (kein Freitext:
 *  das Backend nimmt nur bekannte Projekt-IDs an).
 *
 *  `leerText` gehört zum Aufrufer, nicht hierher: bei Zeit und Pauschale steht
 *  in der Liste nur, wo der Helfer dabei war, beim Lieferschein jede laufende
 *  Baustelle — ein fester Satz wäre in einem der beiden Fälle gelogen. */
export function ProjektAuswahl({
  projekte, value, onChange, platzhalter = "Projekt suchen …",
  leerText = "Nichts gefunden. Du kannst nur Projekte wählen, bei denen du dabei warst.",
}: {
  projekte: ProjektOption[]; value: string; onChange: (id: string) => void;
  platzhalter?: string; leerText?: string;
}) {
  const gewaehlt = projekte.find(p => p.id === value) || null;
  const [text, setText] = useState(gewaehlt?.title || "");
  const [offen, setOffen] = useState(false);
  const treffer = (() => {
    const q = text.trim().toLowerCase();
    if (!q || (gewaehlt && text === gewaehlt.title)) return projekte;
    return projekte.filter(p => p.title.toLowerCase().includes(q));
  })();
  const waehle = (p: ProjektOption) => { onChange(p.id); setText(p.title); setOffen(false); };
  return (
    <div className="vgt-ac">
      <input
        className="vgt-input"
        value={text}
        placeholder={platzhalter}
        autoComplete="off"
        onFocus={() => setOffen(true)}
        onChange={e => { setText(e.target.value); setOffen(true); if (value) onChange(""); }}
        // Blur erst nach dem Klick auswerten, sonst schliesst die Liste,
        // bevor die Auswahl ankommt.
        onBlur={() => setTimeout(() => setOffen(false), 120)}
        onKeyDown={e => { if (e.key === "Enter" && treffer.length === 1) { e.preventDefault(); waehle(treffer[0]); } }}
      />
      {value && <span className="vgt-ac-ok"><VGTIcon name="check" /></span>}
      {offen && (
        <div className="vgt-ac-liste">
          {treffer.length === 0
            ? <div className="vgt-ac-leer">{leerText}</div>
            : treffer.slice(0, 30).map(p => (
              <button key={p.id} type="button" className={"vgt-ac-item" + (p.id === value ? " is-on" : "")}
                      onMouseDown={ev => ev.preventDefault()} onClick={() => waehle(p)}>
                {p.title}
              </button>
            ))}
        </div>
      )}
    </div>
  );
}
